import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import BrandLogo from "@/components/BrandLogo";
import {
  LayoutDashboard, Users, CalendarCheck, Wallet, ArrowLeftRight,
  FileText, Settings as Cog, LogOut,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/admin/employees", label: "Employees", icon: Users, testid: "nav-employees" },
  { to: "/admin/attendance", label: "Attendance", icon: CalendarCheck, testid: "nav-attendance" },
  { to: "/admin/payroll", label: "Payroll", icon: Wallet, testid: "nav-payroll" },
  { to: "/admin/transactions", label: "Advances & Bonus", icon: ArrowLeftRight, testid: "nav-transactions" },
  { to: "/admin/reports", label: "Reports", icon: FileText, testid: "nav-reports" },
  { to: "/admin/settings", label: "Settings", icon: Cog, testid: "nav-settings" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen bg-[#FDFDF9]">
      <aside className="w-64 flex-shrink-0 border-r border-[#E5E2DC] bg-white sticky top-0 h-screen flex flex-col">
        <div className="p-5 border-b border-[#E5E2DC]">
          <div className="flex items-center gap-3">
            <BrandLogo alt="MRS" className="w-11 h-11 rounded-md object-contain" />
            <div>
              <div className="font-serif font-semibold text-slate-900 leading-none">MRS Enterprise</div>
              <div className="text-[10px] uppercase tracking-[0.15em] text-[#C59B27] font-bold mt-1">HRMS</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map(({ to, label, icon: Icon, end, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActive
                    ? "bg-[#111111] text-white"
                    : "text-slate-600 hover:bg-[#FDFDF9] hover:text-slate-900"
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-[#E5E2DC]">
          <div className="px-3 py-2 mb-2">
            <div className="text-xs text-slate-500">Signed in as</div>
            <div className="text-sm font-medium text-slate-900 truncate">{user?.email}</div>
          </div>
          <Button
            onClick={onLogout}
            variant="outline"
            data-testid="logout-button"
            className="w-full justify-start text-slate-600 hover:text-slate-900"
          >
            <LogOut className="w-4 h-4 mr-2" /> Sign out
          </Button>
        </div>
      </aside>
      <main className="flex-1 p-6 md:p-10 max-w-full overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
